class AboutController {
  constructor() {
    this.name = 'about';
  }
}

export default AboutController;



// WEBPACK FOOTER //
// ./app/components/about/about.controller.js